/** The admin area's sidebar and top bar. */
const nav = {
  en: {
    dashboard: "Dashboard",
    products: "Products",
    ranges: "Ranges",
    stock: "Stock levels",
    reminders: "Reminders",
    purchases: "Purchases",
    preorders: "Pre-orders",
    offers: "Offers",
    packs: "Packs",
    revenue: "Net revenue",
    expenses: "Expenses",
    credit: "Credit",
    deliveries: "Deliveries",
    materials: "Materials",
    recipes: "Recipes",
    batches: "Batches",
    shop: "Your shop",
    staff: "Staff",
    cash: "Cash drawer",
    savings: "Savings",
    suppliers: "Suppliers",
    journal: "Journal",
    devices: "Devices",
    modules: "What your shop uses",
    subscription: "Subscription",
    referrals: "Invite a shop",
    settings: "Settings",
    openRegister: "Open register",
    register: "Register",
    logout: "Log out",
    noAccessTitle: "Nothing here has been shared with you yet",
    noAccessHint: "Ask the shop owner to give you access from the Staff screen.",
    menu: "Menu",
    closeMenu: "Close menu",
    groups: {
      catalogue: "Catalogue",
      sales: "Sales",
      money: "Money",
      stock: "Stock",
    },
    hubs: {
      supply: "Supply",
      mixing: "Mixing",
    },
    accountMenu: "Account menu",
    roles: {
      admin: "Admin",
      super_admin: "Platform admin",
      customer: "Customer",
      owner: "Owner",
      staff: "Staff",
    },
  },

  fr: {
    dashboard: "Tableau de bord",
    products: "Produits",
    ranges: "Gammes",
    stock: "Niveaux de stock",
    reminders: "Rappels",
    purchases: "Ventes",
    preorders: "Précommandes",
    offers: "Offres",
    packs: "Packs",
    revenue: "Revenu net",
    expenses: "Dépenses",
    credit: "Crédit",
    deliveries: "Livraisons",
    materials: "Matières",
    recipes: "Recettes",
    batches: "Lots",
    shop: "Votre boutique",
    staff: "Équipe",
    cash: "Tiroir-caisse",
    savings: "Épargne",
    suppliers: "Fournisseurs",
    journal: "Journal",
    devices: "Appareils",
    modules: "Ce que vous utilisez",
    subscription: "Abonnement",
    referrals: "Inviter une boutique",
    settings: "Paramètres",
    openRegister: "Ouvrir la caisse",
    register: "Caisse",
    logout: "Se déconnecter",
    noAccessTitle: "Rien ne vous a encore été ouvert ici",
    noAccessHint: "Demandez au propriétaire de vous donner accès depuis l'écran Équipe.",
    menu: "Menu",
    closeMenu: "Fermer le menu",
    groups: {
      catalogue: "Catalogue",
      sales: "Ventes",
      money: "Argent",
      stock: "Stock",
    },
    hubs: {
      supply: "Approvisionnement",
      mixing: "Mélanges",
    },
    accountMenu: "Menu du compte",
    roles: {
      admin: "Administrateur",
      super_admin: "Admin plateforme",
      customer: "Client",
      owner: "Propriétaire",
      staff: "Employé",
    },
  },

  ar: {
    dashboard: "لوحة التحكم",
    products: "المنتجات",
    ranges: "المجموعات",
    stock: "مستويات المخزون",
    reminders: "التذكيرات",
    purchases: "المبيعات",
    preorders: "الطلبات المسبقة",
    offers: "العروض",
    packs: "الباقات",
    revenue: "صافي الإيرادات",
    expenses: "المصاريف",
    credit: "الديون",
    deliveries: "التوريدات",
    materials: "المواد",
    recipes: "الوصفات",
    batches: "الدفعات",
    shop: "متجرك",
    staff: "الفريق",
    cash: "درج النقود",
    savings: "المدخرات",
    suppliers: "الموردون",
    journal: "السجل",
    devices: "الأجهزة",
    modules: "ما يستخدمه متجرك",
    subscription: "الاشتراك",
    referrals: "دعوة متجر",
    settings: "الإعدادات",
    openRegister: "فتح نقطة البيع",
    register: "نقطة البيع",
    logout: "تسجيل الخروج",
    noAccessTitle: "لم تتم مشاركة أي شيء معك هنا بعد",
    noAccessHint: "اطلب من صاحب المتجر منحك الصلاحيات من شاشة الفريق.",
    menu: "القائمة",
    closeMenu: "إغلاق القائمة",
    groups: {
      catalogue: "الكتالوج",
      sales: "المبيعات",
      money: "المال",
      stock: "المخزون",
    },
    hubs: {
      supply: "التموين",
      mixing: "الخلطات",
    },
    accountMenu: "قائمة الحساب",
    roles: {
      admin: "مسؤول",
      super_admin: "مسؤول المنصة",
      customer: "زبون",
      owner: "المالك",
      staff: "موظف",
    },
  },
};

export default nav;
